<template>
  <header class="main-header w-100 z-10">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark-section fixed11-top" style="">
      <div class="container d-flex align-items-center justify-content-lg-between position-relative">

        <a class="navbar-brand fw-bold" href="/">
          <img :src="vidu_logo" width="113" alt="Vidu logo" class="img-fluid logo-white" />
        </a>

        <div class="d-flex flex-grow-1">

          <ul class="navbar-nav justify-content-center d-none d-lg-flex flex-grow-1" >

            <!--     Блок со ссылками для главной       -->
              <li class="nav-item" v-for="item in menu" :key="item.href">
                <a class="nav-link" :href="item.href">{{ item.label }}</a>
              </li>
            <!--     /Блок со ссылками для главной       -->


          </ul>

          <ul class="navbar-nav d-flex ms-lg-0 ms-auto">

            <li class="nav-item" v-if="customer">
                <span role="button" class="text-white" @click="router.push('/profile/customer')" title="Профиль Зрителя">
                  <i class="bi bi-person-circle navbar-icon"></i>
                </span>
            </li>

            <li class="nav-item" v-if="author">
                <span role="button" class="text-white" @click="router.push('/profile/author')" title="Профиль Автора" >
                  <i class="bi bi-person-circle navbar-icon"></i>
                </span>
            </li>

            <li class="nav-item" v-if="!customer && !author">
              <router-link to="/login" class="btn btn-primary">Войти в аккаунт</router-link>
            </li>
            <li class="nav-item" v-else>
              <i class="bi bi-box-arrow-right navbar-icon" role="button" @click="logout"></i>
            </li>

          </ul>

        </div>


      </div>
    </nav>
  </header>
</template>

<script setup>
import {computed, ref} from "vue";
import { useStore } from "@/store";
import router from "@/router";
import vidu_logo from "@/assets/vidu_logo.png";
import {logout} from "@/helpers/back";

const store = useStore();
const customer = computed(() => store.getP('customer'));
const author = computed(() => store.getP('author'));
const baseUrl = window.location.origin;
const currUrl = router.currentRoute.value.path

const menu = computed( () => {
  if(router.currentRoute.value.name === 'Home') {
    return [
      { label: "Как это работает", href: `${baseUrl}#how-it-works` },
      { label: "Преимущества", href: `${baseUrl}#benefits` },
      { label: "Как начать", href: `${baseUrl}#start` },
      { label: "FAQ", href: `${baseUrl}#faq` },
    ]
  }
  else if(router.currentRoute.value.path.startsWith("/profile/author")) {
    return [
      { label: "Конструктор", href: `/profile/author/constructor` },
      { label: "Статистика", href: `/profile/author/stats` },
      { label: "Настройки", href: `/profile/author` },
    ]
  }

})

</script>
